import React from 'react'

function Icon({ fill = '#D16643' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="85"
      viewBox="0 0 86 85"
      fill="none"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M84.41 42.34A41.08 41.08 0 1143.34 1.26a41.07 41.07 0 0141.07 41.08v0zM42.4 12.59L13.34 41.65m45.04-25.1L17.32 57.61m51.03-31.09L27.29 67.58M72.31 42.5L43.25 71.56"
      ></path>
    </svg>
  )
}

export default Icon
